module.exports = __webpack_public_path__ + "static/amore-fe04915f2373a6ba2c9896bbaa2835ae.png";